module.exports = __webpack_public_path__ + "img/C2.8dfa5412.png";